import { useMemo } from 'react';

import { getServerErrorText } from 'shared/lib';
import { ErrorMessage, EmptyData } from 'shared/ui';

import { useGetTariffsQuery } from 'entities/tariff';

import { TariffsTableInstance } from './table';

export function ConnectedTariffsTable() {
  const { data, isFetching, error } = useGetTariffsQuery();

  const tableData = useMemo(() => {
    if (!data) {
      return [];
    }

    return data.chargeTariffs;
  }, [data]);

  if (data && data.statusCode !== 0) {
    return <ErrorMessage text={data.statusDescription} />;
  }

  if (error) {
    return <ErrorMessage text={getServerErrorText(error)} />;
  }

  if (!isFetching && !data) {
    return <EmptyData />;
  }

  return (
    <TariffsTableInstance
      tableData={tableData}
      loading={isFetching}
      rowsCount={data?.chargeTariffs.length}
    />
  );
}
